import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/envelope-open': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M494.6 164.5C489.9 160.6 382.9 74.6 359.3 55.9 337.2 38.2 299.4 0 256 0 212.8 0 175.4 37.7 152.7 55.9 128.2 75.3 21.6 161.1 17.5 164.4A48-48 0 0 1 0 201.5V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V201.5A48-48 0 0 1 494.6 164.5zM464 458A6-6 0 0 0 458 464H54A6-6 0 0 0 48 458V204.3C48 202.5 48.8 200.8 50.2 199.7 66.1 186.9 159 112.1 182.6 93.4 200.8 78.9 232.4 48 256 48 279.7 48 311.9 79.4 329.4 93.4 353 112.1 445.9 186.9 461.8 199.7A6-6 0 0 0 464 204.4V458zM432 270.3C436.3 275.5 435.5 283.1 430.3 287.3 401.3 310.6 371 334.9 359.3 344.1 336.6 362.3 299.2 400 256 400 212.5 400 174.7 361.8 152.7 344.1 141.4 335.2 110.9 310.7 81.7 287.3 76.5 283.1 75.7 275.5 80 270.3L95.3 251.8C99.4 246.7 106.9 245.9 112 250 140.6 273 170.6 297.1 182.6 306.6 200.1 320.6 232.3 352 256 352 279.6 352 311.2 321.1 329.4 306.6 341.4 297.1 371.4 273 400 250 405.1 245.9 412.6 246.7 416.8 251.8L432 270.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/envelope-open.js
// module id = uOCW
// module chunks = 144